import type { EntityConfig } from "../hooks/useEntity";

export const collaborationEntityConfig: EntityConfig = {
  name: "Collaboration",
  orderBy: "created_at DESC",
  properties: {
    documentId: { type: "integer", description: "Associated document ID" },
    userId: { type: "integer", description: "Collaborator user ID" },
    email: { type: "string", description: "Collaborator email" },
    displayName: { type: "string", description: "Preferred name for collaborator" },
    role: {
      type: "string",
      enum: ["owner", "editor", "commenter", "viewer"],
      description: "Collaboration role and permissions",
    },
    invitedBy: { type: "integer", description: "User ID who sent the invitation" },
    status: {
      type: "string",
      enum: ["pending", "accepted", "declined"],
      default: "pending",
      description: "Invitation status",
    },
    lastAccessedAt: { type: "string", format: "date", description: "Last access timestamp" },
  },
  required: ["documentId", "userId", "email", "role", "invitedBy"],
};
